/* eslint-disable react/prop-types */
import React, { useState, useEffect, useContext, useRef } from "react";
// @mui material components
import { Link } from "react-router-dom";
// Material Dashboard 2 React components
import {
  IconButton,
  TextField,
  Button,
  Alert,
  Box,
  Grid,
  Dialog,
  Snackbar,
  Typography,
  DialogTitle,
  DialogContent,
  DialogActions,
  FormHelperText,
  FormControl,
  Autocomplete,
} from "@mui/material";
import { Select, MenuItem } from "@mui/material";
import { Cancel, Delete } from "@mui/icons-material";
import CloseIcon from "@mui/icons-material/Close";
import SaveIcon from "@mui/icons-material/Save";
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";
import {
  MenuProps,
  useStyles,
  PaperComponent,
  convertNumbersToStrings,
} from "../../../utils/constants";
import { useTheme } from "@mui/material/styles";

const defaultValue = {
  nhombotieuchi: "",
  nhomsanpham: "",
  ma: "",
  ten: "",
  ghichhu: null,
  diem: 1,
};
const formBoTieuChi = ({
  data,
  open,
  onClose,
  onSubmit,
  title,
  validationErrors,
  dataNhom,
  dataNhomSanPham,
}) => {
  const [errors, setErrors] = useState({
    nhombotieuchi: "",
    nhomsanpham: null,
    ma: "",
    ten: "",
    ghichu: "",
    diem: "",
    error: "",
  });
  const [dataState, setDataState] = useState(defaultValue);
  const theme = useTheme();
  const axiosPrivateInstance = useAxiosPrivate();
  const classes = useStyles();
  const [value, setValue] = useState(0);
  const [isError, setIsError] = useState(false);
  const [alert, setAlert] = useState({
    alert: false,
    message: null,
    type: null,
  });

  const formRef = useRef(null);

  async function onSubmitForm(event) {
    event.preventDefault();
    const _data = { ...dataState };
    convertNumbersToStrings(_data);
    _data["id"] = data?.id;
    _data["rowIndex"] = data?.rowIndex;
    const newValidationErrors = validateOBJ(_data);
    let _tempValid = newValidationErrors;

    if (Object.values(_tempValid).some((error) => error)) {
      setErrors(newValidationErrors);
      return;
    }
    onSubmit(_data);
    setErrors({});
  }

  const handelClear = () => {
    onClose();
    setErrors([]);
  };

  useEffect(() => {
    if (validationErrors?.another) {
      setAlert({
        alert: true,
        message: validationErrors?.another,
        type: "error",
      });
    } else {
      setErrors(validationErrors);
    }
  }, [validationErrors]);

  useEffect(() => {
    if (data?.id) {
      let newData = data;
      setDataState(newData);
    } else {
      setDataState(defaultValue);
    }
  }, [data]);

  useEffect(() => {
    if (open) {
      setValue(0);
      setErrors([]);
    }
  }, [open]);

  const handleChangeValueInput = (name) => (e) => {
    let { value } = e.target;
    setDataState((prev) => {
      return {
        ...prev,
        [name]: value,
      };
    });
  };
  const handleChangeNhombotieuchi = (e) => {
    const value = e.target.value;
    setDataState((prev) => {
      return {
        ...prev,
        nhombotieuchi: value,
      };
    });
  };
  const handleChangeNhomsanpham = (e) => {
    const value = e.target.value;
    setDataState((prev) => {
      return {
        ...prev,
        nhomsanpham: value,
      };
    });
  };
  const handleCloseAlert = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setAlert({ alert: false, message: null, type: null });
  };
  const handleChangeAutoComplete = (name, unicode) => (e, newValue) => {
    setDataState((prev) => ({
      ...prev,
      [name]: newValue ? newValue[unicode] : null,
    }));
  };
  const handleToFocus = (key) => (e) => {
    setErrors((prev) => ({
      ...prev,
      [key]: "",
    }));
  };
  return (
    <>
      <Dialog open={open} PaperComponent={PaperComponent}>
        {/* Form chỉnh sửa tạo mới giá đất */}
        <form ref={formRef} method="post" encType="multipart/form-data">
          {/* Tiêu đề modal - tham số title */}
          <DialogTitle sx={{ m: 0, p: 2 }}>
            {title ? title : "Bộ tiêu chí"}
            <IconButton
              aria-label="close"
              onClick={handelClear}
              sx={{
                position: "absolute",
                right: 8,
                top: 8,
                color: (theme) => theme.palette.grey[500],
              }}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent dividers>
            {alert.alert && (
              <Snackbar
                autoHideDuration={3000}
                anchorOrigin={{ vertical: "top", horizontal: "right" }}
                open={alert.alert}
                onClose={handleCloseAlert}
              >
                <Alert onClose={handleCloseAlert} severity={alert.type}>
                  {alert.message}
                </Alert>
              </Snackbar>
            )}
            <Box sx={{ p: 1 }}>
              {/* show lỗi từ khi không xác định được từ các field ở form */}
              {errors && errors.error ? (
                <Grid container sx={{ textAlign: "center", mb: 0 }}>
                  <Grid item xs={12}>
                    <Alert severity="error" sx={{ mb: 3, mt: 0 }}>
                      {errors.error}
                    </Alert>
                  </Grid>
                </Grid>
              ) : (
                ""
              )}
              <Grid container spacing={2} sx={{ textAlign: "left" }}>
                <Grid item xs={12} md={12} lg={12}>
                  <Typography
                    fontSize={"0.75rem"}
                    color={"#000000"}
                    fontWeight={500}
                  >
                    Nhóm sản phẩm <span style={{ color: "red" }}>*</span>
                  </Typography>
                  <Autocomplete
                    id={`combo-box-nhomsanpham`}
                    options={dataNhomSanPham?.length > 0 ? dataNhomSanPham : []}
                    getOptionLabel={(option) => option?.ten}
                    value={
                      dataNhomSanPham?.find(
                        (option) => option?.id === dataState?.nhomsanpham
                      ) || null
                    }
                    onFocus={handleToFocus("nhomsanpham")}
                    onChange={handleChangeAutoComplete("nhomsanpham", "id")}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        placeholder={`Chọn nhóm sản phẩm`}
                        error={errors ? !!errors?.nhomsanpham : false}
                        helperText={errors?.nhomsanpham}
                      />
                    )}
                    renderOption={(props, options) => (
                      <Box component="li" {...props} key={options?.id}>
                        {options?.ten}
                      </Box>
                    )}
                    fullWidth
                    size="medium"
                    sx={{
                      ".MuiAutocomplete-input": {
                        padding: "3px 3px 3px 16px !important",
                      },
                    }}
                  />
                </Grid>
                <Grid item xs={12} md={12} lg={12}>
                  <Typography
                    fontSize={"0.75rem"}
                    color={"#000000"}
                    fontWeight={500}
                  >
                    Nhóm <span style={{ color: "red" }}>*</span>
                  </Typography>
                  <Autocomplete
                    id={`combo-box-nhom`}
                    getOptionLabel={(option) => option?.ten}
                    options={
                      dataNhom?.length > 0
                        ? dataNhom.sort(
                            (a, b) =>
                              -b.nhomcha_ten.localeCompare(a.nhomcha_ten)
                          )
                        : []
                    }
                    groupBy={(option) => option.nhomcha_ten}
                    value={
                      dataNhom?.find(
                        (option) => option?.id === dataState?.nhombotieuchi
                      ) || null
                    }
                    onFocus={handleToFocus("nhombotieuchi")}
                    onChange={handleChangeAutoComplete("nhombotieuchi", "id")}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        placeholder={`Chọn nhóm`}
                        error={errors ? !!errors?.nhombotieuchi : false}
                        helperText={errors?.nhombotieuchi}
                      />
                    )}
                    renderOption={(props, options) => (
                      <Box component="li" {...props} key={options?.id}>
                        {options?.ten}
                      </Box>
                    )}
                    fullWidth
                    size="medium"
                    sx={{
                      ".MuiAutocomplete-input": {
                        padding: "3px 3px 3px 16px !important",
                      },
                    }}
                  />
                </Grid>
                {/* <Grid item xs={3}>
                  <Typography
                    fontSize={"0.75rem"}
                    color={"#000000"}
                    fontWeight={500}
                  >
                    Mã bộ tiêu chí <span style={{ color: "red" }}>*</span>
                  </Typography>
                  <TextField
                    value={dataState.ma}
                    error={errors ? !!errors.ma : false}
                    onFocus={() => {
                      setErrors({
                        ...errors,
                        ma: "",
                      });
                    }}
                    placeholder="Nhập mã bộ tiêu chí"
                    helperText={errors.ma}
                    sx={{ width: "100%" }}
                    onChange={handleChangeValueInput("ma")}
                    name="ma"
                  />
                </Grid> */}
                <Grid item xs={12}>
                  <Typography
                    fontSize={"0.75rem"}
                    color={"#000000"}
                    fontWeight={500}
                  >
                    Tên bộ tiêu chí <span style={{ color: "red" }}>*</span>
                  </Typography>
                  <TextField
                    value={dataState.ten}
                    error={errors ? !!errors.ten : false}
                    onFocus={() => {
                      setErrors({
                        ...errors,
                        ten: "",
                      });
                    }}
                    placeholder="Nhập tên bộ tiêu chí"
                    helperText={errors.ten}
                    sx={{ width: "100%" }}
                    onChange={handleChangeValueInput("ten")}
                    name="ten"
                  />
                </Grid>
                <Grid item xs={3}>
                  <Typography
                    fontSize={"0.75rem"}
                    color={"#000000"}
                    fontWeight={500}
                  >
                    Thang điểm
                  </Typography>
                  <TextField
                    value={dataState.diem}
                    name="diem"
                    type="number"
                    error={errors ? !!errors.diem : false}
                    placeholder="Nhập thang điểm"
                    helperText={errors.diem}
                    sx={{ width: "100%" }}
                    onChange={handleChangeValueInput("diem")}
                    inputProps={{ pattern: "[0-9]*" }}
                    InputProps={{
                      inputProps: {
                        style: { textAlign: "right" },
                      },
                    }}
                  />
                </Grid>
                <Grid item xs={9}>
                  <Typography
                    fontSize={"0.75rem"}
                    color={"#000000"}
                    fontWeight={500}
                  >
                    Ghi chú
                  </Typography>
                  <TextField
                    value={dataState.ghichu}
                    // error={errors ? !!errors.ten : false}
                    placeholder="Nhập ghi chú"
                    helperText={errors.ghichu}
                    sx={{ width: "100%" }}
                    onChange={handleChangeValueInput("ghichu")}
                    name="ghichu"
                  />
                </Grid>
              </Grid>
            </Box>
          </DialogContent>
          <DialogActions>
            <Button
              color="secondary"
              type="button"
              variant="contained"
              startIcon={<Cancel />}
              size="small"
              onClick={handelClear}
              sx={{ color: "#ffffff", float: "right", mr: 1 }}
            >
              Hủy
            </Button>
            <Button
              type="submit"
              variant="contained"
              startIcon={<SaveIcon />}
              size="small"
              onClick={onSubmitForm}
              sx={{ color: "#ffffff", float: "right", mr: 1 }}
            >
              Lưu
            </Button>
          </DialogActions>
        </form>
      </Dialog>
    </>
  );
};

const validateRequired = (value) => {
  let result = !!value?.length;
  if (typeof value == "number") {
    result = true;
  }
  return result;
};

function validateOBJ(gd) {
  return {
    nhomsanpham: !validateRequired(gd.nhomsanpham)
      ? "Nhóm sản phẩm không được trống"
      : "",
    nhombotieuchi: !validateRequired(gd.nhombotieuchi)
      ? "Nhóm không được trống"
      : "",
    ten: !validateRequired(gd.ten) ? "Tên bộ tiêu chí không được trống" : "",
    // ma: !validateRequired(gd.ma) ? "Mã bộ tiêu chí không được trống" : "",
    diem: !validateRequired(gd.diem)
      ? "Thang điểm không được trống. Phải là dạng số"
      : "",
  };
}

export default formBoTieuChi;
